import type { SVGProps } from 'react';

const SvgLightningOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M14.34 1.06A1 1 0 0 1 15 2v7h5a1 1 0 0 1 .768 1.64l-10 12A1 1 0 0 1 9 22v-7H4a1 1 0 0 1-.768-1.64l10-12a1 1 0 0 1 1.108-.3M6.135 13H11v6.238L17.865 11H13V4.762z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgLightningOutline;
